const initialState = { data: [], errors: {} };

const insertCreatedTravelingWorkDate = (state, payload) => {
  const data = [...state.data];
  if (data.length > 0 && data[0].id === 'new') data[0] = payload.traveling_work_date;
  else data.unshift(payload.traveling_work_date);
  return data;
};

const handleTravelingWorkDateCreateErrors = (state, payload) => {
  const errTravelingWorkDate = { ...payload.traveling_work_date, errors: payload.errors, id: 'new' };
  const data = [...state.data];
  if (data.length > 0 && data[0].id === 'new') data[0] = errTravelingWorkDate;
  else data.unshift(errTravelingWorkDate);
  return data;
};

const travelingWorkDates = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'TRAVELING_WORK_DATE_INDEX_SUCCESS':
      return { ...state, data: payload.traveling_work_dates };
    case 'TRAVELING_WORK_DATE_CREATE_SUCCESS':
      return {
        ...state,
        data: insertCreatedTravelingWorkDate(state, payload),
      };
    case 'TRAVELING_WORK_DATE_UPDATE_SUCCESS':
      return {
        ...state,
        data: state.data.map(traveling_work_date =>
          (traveling_work_date.id === payload.traveling_work_date.id ?
            payload.traveling_work_date : traveling_work_date)),
      };
    case 'TRAVELING_WORK_DATE_DELETE_SUCCESS':
      return {
        ...state,
        data: state.data.filter(traveling_work_date =>
          traveling_work_date.id !== payload.travelingWorkDateID), // Make sure this is right
      };
    case 'TRAVELING_WORK_DATE_INDEX_FAILURE':
      return { ...state, errors: payload.errors };
    case 'TRAVELING_WORK_DATE_CREATE_FAILURE':
      return { ...state, data: handleTravelingWorkDateCreateErrors(state, payload) };
    case 'TRAVELING_WORK_DATE_UPDATE_FAILURE':
    case 'TRAVELING_WORK_DATE_DELETE_FAILURE':
      return {
        ...state,
        data: state.data.map(traveling_work_date => (
          traveling_work_date.id === payload.traveling_work_date.id ?
            { ...payload.traveling_work_date, errors: payload.errors } : traveling_work_date)),
      };
    case 'TRAVELING_WORK_DATE_INDEX_REQUEST':
    case 'TRAVELING_WORK_DATE_CREATE_REQUEST':
    case 'TRAVELING_WORK_DATE_UPDATE_REQUEST':
    case 'TRAVELING_WORK_DATE_DELETE_REQUEST':
      return { ...state, loading: true };
    default:
      return state;
  }
};

export default travelingWorkDates;



// WEBPACK FOOTER //
// ./client/app/reducers/traveling_work_dates.js